import { useQueryParam, withDefault } from "use-query-params";

import { DEFAULT_CHART_STATE } from "@features/sales-v4/constants";
import { type ChartState } from "@features/sales-v4/types";
import { CustomJsonCompressedParam } from "@north-beam/nb-common";

const ChartStatesParam = CustomJsonCompressedParam<ChartState>();

export const useChartStateQueryParams = () => {
  const [chartState, setChartState] = useQueryParam(
    "chartStates",
    withDefault<ChartState, ChartState>(ChartStatesParam, DEFAULT_CHART_STATE),
    { updateType: "pushIn", enableBatching: false },
  );

  return {
    chartState,
    setChartState,
  };
};
